import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import {
  PopupContainer,
  StyledPopupBox,
  PopupImageBox,
  PopupOverlay
} from '../styles/LandingPage'; 
import PopupImage from '../assets/images/landing/landing-popup.png';

const Popup = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null; // Avoid rendering the popup if not visible

  return (
    <PopupOverlay show={show}>
      <PopupContainer show={show}>
        <StyledPopupBox>
          <PopupImageBox src={PopupImage} alt="Popup Image" />
          <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold', color: '#2C5296' }}>
            Ask, Learn, and Solve - Your AI Expert Awaits
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, color: '#666' }}>
            Get instant, precise answers to your oil and gas queries with Genie AI.
            Enhance productivity and streamline operations effortlessly.
          </Typography>
        </StyledPopupBox>
      </PopupContainer>
    </PopupOverlay>
  );
};

export default Popup;
